// extracted by mini-css-extract-plugin
export default {"footerArea":"Footer_footerArea__m7MGv"};